import React from 'react';
import {DubiousOrganizations} from "../../components";

const Dubious = () => {
    return (
        <DubiousOrganizations/>
    );
};

export default Dubious;